import { createContext, ReactNode, useContext, useReducer } from "react";

// Interface
type Tab = "buy" | "sell";

interface TradeContextValue {
  tab: Tab;
}

// Initial State and Actions
const initialState: any = {
  tab: "buy",
};

const actions = {
  UPDATE_TAB_VIEW: "UPDATE_TAB_VIEW",
};

// Reducer to Handle Actions
const reducer = (state: TradeContextValue, action: any) => {
  switch (action.type) {
    case actions.UPDATE_TAB_VIEW:
      return {
        ...state,
        tab: action.newTab,
      };
    default:
      return state;
  }
};

// Context and Provider
export const TradeContext = createContext(initialState);

export function TradeContextProvider({ children }: { children?: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = {
    ...state,
    updateTabView: (newTab: Tab) => {
      dispatch({ type: actions.UPDATE_TAB_VIEW, newTab });
    },
  };

  return (
    <TradeContext.Provider value={value}>{children}</TradeContext.Provider>
  );
}

export function useTradeContext() {
  return useContext(TradeContext);
}
